<template>
	<v-col class="inbox">
		<ModalSearch ref="modalSearch" @action="cari"></ModalSearch>
		<ModalConfirm ref="modalConfirm" :msg="msgConfirm" @action="processMessage"></ModalConfirm>
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Pesan Terkirim</div>
		</div>
		<div class="pt-1 pb-2 d-flex flex-wrap font-size-10 grey--text">
			<v-icon small color="grey">mdi-email</v-icon>
			<div class="pl-2">Pesan</div>
			<div class="px-2">/</div>
			<div>Pesan Terkirim</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="12" class="py-0 py-sm-3">
					<div class="d-flex justify-end">
						<v-btn depressed color="primary" class="white--text rounded-lg text-capitalize" @click="showSearch">
							<div class="d-flex">
								<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
								<div class="d-none d-sm-block">Cari</div>
							</div>
						</v-btn>
						<v-btn depressed color="grey lighten-1" class="ml-3 white--text rounded-lg text-capitalize" @click="reset">Reset</v-btn>
					</div>
				</v-col>
			</v-row>
			<div v-if="!loading">
				<v-row v-if="listMessageSent.length > 0">
					<v-col cols="12" class="pt-0">
						<v-simple-table class="white-row table-vo table-history-bonus">
							<template v-slot:default>
								<thead class="">
									<tr>
										<th class="text-left" width="20%">Dikirim Kepada</th>
										<th class="text-center" width="16%">Kode Mitra</th>
										<th class="text-left" width="34%">Pesan</th>
										<th class="text-left" width="20%">Tanggal</th>
										<th class="text-center" width="10%">Aksi</th>
									</tr>
								</thead>
								<tbody class="grey--text text--darken-3">
									<tr class="cursor-pointer" v-for="message in listMessageSent" :key="message.message_id">
										<td class="text-left" @click="detailMessage(message.message_id)">
											<div v-if="!message.message_receive_name">Sistem</div>
											<div v-else>{{ message.message_receive_name | emptyData }}</div>
										</td>
										<td class="text-center" @click="detailMessage(message.message_id)">
											<div v-if="!message.message_receive_network_code">Sistem</div>
											<div class="pa-1 bg-primary-2 cl-white font-weight-bold rounded-pill" v-else>{{ message.message_receive_network_code }}</div>
										</td>
										<td class="text-left max-width-0" @click="detailMessage(message.message_id)">
											<div class="product-name" v-html="message.message_content"></div>
										</td>
										<td class="text-left" @click="detailMessage(message.message_id)">{{ message.message_datetime | tanggaljam }}</td>
										<td class="text-center">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn class="max-width-0 my-1 my-md-0" text x-small depressed color="blue" v-bind="attrs" v-on="on" @click="showConfirm(message.message_id, 'archive')">
														<v-icon dark>mdi-package-down</v-icon>
													</v-btn>
												</template>
												<span>Arsipkan</span>
											</v-tooltip>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn class="max-width-0 my-1 my-md-0" text x-small depressed color="red" v-bind="attrs" v-on="on" @click="showConfirm(message.message_id, 'delete')">
														<v-icon dark>mdi-delete</v-icon>
													</v-btn>
												</template>
												<span>Hapus</span>
											</v-tooltip>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="listMessageSent.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
								<v-img eager class="mx-auto" width="180" height="180" src="/assets/icon/empty-message.png"></v-img>
								<div class="pt-3 text-center cl-secondary">Tidak ada pesan yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
				<div v-if="listMessageSent.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="messageSentPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ messageSentPagination.total_display }} data dari total {{ messageSentPagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="mt-4" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalSearch from './components/ModalSearch';
import ModalConfirm from '@/components/modals/vo/ModalConfirm';

export default {
	components: {
		ModalSearch, ModalConfirm
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			params: [],
			msgConfirm: '',
			messageId: '',
			messageAction: '',
			sort: 'message_datetime',
			dir: 'DESC',
		}
	},
	computed: {
		...mapState('message', ['listMessageSent', 'messageSentPagination']),
	},
	methods: {
		...mapActions('message', ['getMessageSent', 'deleteMessage', 'archiveMessage']),

		getData() {
			this.loading = true
			this.getMessageSent(this.queryString({limit:this.limit, page: this.page, params: this.params, sort: this.sort, dir: this.dir})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		showSearch() {
			this.$refs.modalSearch.modalShow()
		},
		reset() {
			this.page = 1
			this.limit = '10'
			this.params = []
			this.getData()
			this.$refs.modalSearch.reset()
		},
		cari(data) {
			this.params = []
			this.page = 1

			if(data.name.value)
				this.params.push(data.name)
			if(data.code.value)
				this.params.push(data.code)
			if(data.message.value)
				this.params.push(data.message)
			if(data.date.value)
				this.params.push(data.date)
			this.getMessageSent(this.queryString({limit:this.limit, page: this.page, params: this.params, sort: this.sort, dir: this.dir})).then(() => {
				this.$refs.modalSearch.modalHide()
			})
		},
		detailMessage(id) {
			this.$router.push({ name: 'detail-pesan-terkirim', params: { id: id } })
		},
		showConfirm(id, action) {
			this.messageId = id
			this.messageAction = action
			if (action == 'archive') {
				this.msgConfirm = 'Yakin ingin mengarsipkan pesan?'
				this.$refs.modalConfirm.modalShow()
			}
			if (action == 'delete') {
				this.msgConfirm = 'Yakin ingin menghapus pesan?'
				this.$refs.modalConfirm.modalShow()
			}
		},
		processMessage() {
			if (this.messageAction == 'archive') {
				let data = []
				data.push(this.messageId)
				this.$refs.modalConfirm.loadingButton()
				this.archiveMessage({data}).then(() => {
					this.$refs.modalConfirm.normalButton()
					this.$refs.modalConfirm.modalHide()
					this.getData()
				}).catch(() => {
					this.$refs.modalConfirm.normalButton()
				})
			}
			if (this.messageAction == 'delete') {
				let data = []
				data.push(this.messageId)
				this.$refs.modalConfirm.loadingButton()
				this.deleteMessage({data}).then(() => {
					this.$refs.modalConfirm.normalButton()
					this.$refs.modalConfirm.modalHide()
					this.getData()
				}).catch(() => {
					this.$refs.modalConfirm.normalButton()
				})
			}
		}
	},
	created(){
		this.$store.dispatch('setPageTitle', `Pesan Terkirim`)
		this.getData()
	}
};
</script>